import axios from ".";

/**
 * Change user password
 * @param current_password The current password
 * @param new_password The new password
 * @param confirm_password Confirmation of the new password
 * @returns Promise with success message
 */
export const changePassword = async ({
  current_password,
  new_password,
  confirm_password,
}: {
  current_password: string;
  new_password: string;
  confirm_password: string;
}) => {
  return axios.patch("/user/change-password", {
    current_password,
    new_password,
    confirm_password,
  });
};

/**
 * Force password change for users with temporary passwords
 * @param new_password The new password
 * @param confirm_password Confirmation of the new password
 * @returns Promise with updated user data
 */
export const forceChangePassword = async ({
  new_password,
  confirm_password,
}: {
  new_password: string;
  confirm_password: string;
}) => {
  return axios.post("/auth/force-change-password", {
    new_password,
    confirm_password,
  });
};

/**
 * Request password reset email
 * @param email The user's email address
 * @returns Promise with success message
 */
export const forgotPassword = async ({ email }: { email: string }) => {
  return axios.post("/auth/forgot-password", { email });
};

/**
 * Reset password using token from email
 * @param token The reset token from email
 * @param new_password The new password
 * @param confirm_password Confirmation of the new password
 * @returns Promise with success message
 */
export const resetPassword = async ({
  token,
  new_password,
  confirm_password,
}: {
  token: string;
  new_password: string;
  confirm_password: string;
}) => {
  return axios.post("/auth/reset-password", {
    token,
    new_password,
    confirm_password,
  });
};
